G.BoardMatcher = function(board) {

	this.board = board;
	this.specialsCoordinates = G.Helpers.candyDataMgr.getSpecialPatterns();

	this.grid = new G.GridArray(this.board.boardData.width,this.board.boardData.height,false);
	this.grid.set = function(x,y,val) {
		if (this.isInGrid(x,y)) {

			if (!this.data[x][y]) {
				return this.data[x][y] = val;
			}

			if (this.data[x][y] == 'm' && val != 'm') {
				return this.data[x][y] = val;
			}

		}else {
			return false;
		}
	};

	this.tempGrid = new G.GridArray(this.board.boardData.width,this.board.boardData.height,false);

	this.hitGrid = new G.GridArray(this.board.boardData.width,this.board.boardData.height,false);


	this.toCheck = [];

};



G.BoardMatcher.prototype.isMoveValid = function(candy) {

	var cellX = candy.cellX;
	var cellY = candy.cellY;

	if (!this.board.isCellMatchable(cellX,cellY)) return false;
	if (candy.hasSpecialType() && candy.isSpecialActivatedByMove()) return true;
	if (this.quickCheckCoords(candy,this.horCoords,false)) return true;
	if (this.quickCheckCoords(candy,this.verCoords,false)) return true;
	//if (this.quickCheckCoords(candy,this.birdCoords,false)) return true;

	return false;

};

G.BoardMatcher.prototype.quickMatchCheck = function(candy) {

  if (!candy) return false;

	var cellX = candy.cellX;
	var cellY = candy.cellY;

	if (!this.board.isCellMatchable(cellX,cellY)) return false;
	if (this.quickCheckCoords(candy,this.horCoords,false)) return true;
	if (this.quickCheckCoords(candy,this.verCoords,false)) return true;
	//if (this.quickCheckCoords(candy,this.birdCoords,false)) return true;

	return false;

};


G.BoardMatcher.prototype.checkPossibleMoves = function() {

	var result = [];

	
	this.board.boardCandies.grid.loop(function(elem,x,y) {

		if (!elem) return;

		if (!this.board.isMoveable(elem.cellX,elem.cellY) || !this.board.isCellMatchable(elem.cellX,elem.cellY)) return;

    if (this.checkMove(elem, x+1, y, this.possibleRightMoves)) {
      result.push([x,y,x+1,y]);
    }

    if (this.checkMove(elem, x-1, y, this.possibleLeftMoves)) {
      result.push([x,y,x-1,y]);
    }

    if (this.checkMove(elem, x, y-1, this.possibleUpMoves)) {
      result.push([x,y,x,y-1]);
    }

    if (this.checkMove(elem, x, y+1, this.possibleDownMoves)) {
      result.push([x,y,x,y+1]);
    }

	},this); 
 
	return result;

};

G.BoardMatcher.prototype.checkMove = function(candy, x, y, possibleMoves) {
	if (!candy) return false;
	if (!this.board.isMoveable(x, y)) return false;

	const candy2 = this.board.getCandy(x, y);

	return (candy.isSpecialActivatedByMove(candy2.baseTypeData.id)
		|| G.Helpers.candyDataMgr.getTypesCombo(
			candy.getSpecialTypeName(), candy2.getSpecialTypeName())
		|| this.quickCheckCoords(candy, possibleMoves, false));
}


//
// checks if candies in given coordinates are matchable with given candy
// IF THEY MAKE A MATCH
// 
// 3rd parameter - if all coordinates on list have to pass
//
// RETURN bool;
//
G.BoardMatcher.prototype.quickCheckCoords = function(candy,data,all) {


	var cellX = candy.cellX;
	var cellY = candy.cellY;
	var coords;
	var test;

	for (var i = 0, len = data.length; i < len; i++) {

		coords = data[i];
		test = true;

		for (var j = 0, len2 = coords.length; j < len2; j+=2) {
			if (!this.board.isCellMatchable(cellX+coords[j],cellY+coords[j+1],candy)) {
				test = false;
				break;
			}
		}

		if (all && !test) {
			return false;
		}
		if (!all && test) {
			return true;
		}

	}

	return all ? true : false;

};


//main function - checks matches for candies list
//first fills matchGird with 'm'
//then fills and process hit grid
G.BoardMatcher.prototype.processMatchList = function() {

	if (this.board.checkMatchList.length == 0 && this.board.checkSpecialMatchList.length == 0) return;

	G.lvl.increaseCombo();

	G.sfx['match_'+game.math.clamp((G.lvl.combo || 1),1,5)].play();

	//clear change grid
	this.candiesToProcess = this.board.checkMatchList;
	this.specialCandiesToProcess = this.board.checkSpecialMatchList;


	for (var i = 0, len = this.candiesToProcess.length; i < len; i++) {

		if (this.grid.get(this.candiesToProcess[i].cellX,this.candiesToProcess[i].cellY)) continue;

		if (this.candiesToProcess[i].hasSpecialType() && this.candiesToProcess[i].isSpecialActivatedByMove()) {
			this.specialCandiesToProcess.push(this.candiesToProcess[i]);
		}else {
			this.processTemp(this.candiesToProcess[i]);
		}
	}

	//infate before specials process
	this.inflateHitGrid();


	for (var j = 0; j < this.specialCandiesToProcess.length; j++) {
		
		//this.processSpecial(this.specialCandiesToProcess[j]);
		this.processTempSpecial(this.specialCandiesToProcess[j]);

	};

  this.board.checkMatchList = [];
  this.board.checkSpecialMatchList = [];

	this.processGrid();
	this.processHitGrid();
	
	this.grid.clear();
	this.hitGrid.clear();

};

G.BoardMatcher.prototype.inflateHitGrid = function() {

	this.grid.loop(function(elem,x,y) {
		if (elem) {
			this.hitGrid.set(x-1,y,'h');
			this.hitGrid.set(x+1,y,'h');
			this.hitGrid.set(x,y-1,'h');
			this.hitGrid.set(x,y+1,'h');
		}
	},this);

};


G.BoardMatcher.prototype.processHitGrid = function() {

	this.hitGrid.loop(function(elem,x,y) {
		if (elem) {
			this.board.hitCell(x,y);
		}
	},this);

};


G.BoardMatcher.prototype.processGrid = function() {

  var changedIntoSpecials = [];

	this.grid.loop(function(elem,x,y) {

		if (elem) {
			if (elem == 'm') {
				/*var candy = this.board.getCandy(x,y);
				if (candy) candy.match();*/
				this.board.matchCell(x,y);
			}else {
				if (elem[0] == 'change') {
					if (this.board.getCandy(x,y)) {this.board.getCandy(x,y).changeInto(elem[1])};
					//without that, if change is in cage, cage will be intact
					this.board.matchCellExceptCandy(x,y);

          changedIntoSpecials.push(this.board.getCandy(x,y));
				}
				if (elem[0] == 'match-move') this.board.matchCell(x,y,elem[1],elem[2],elem[3]);
			}	
		}
	},this);


  // check if candy change into special is able to match again
  // in case of special that was created from candies under concrete
  // C S C C
  changedIntoSpecials.forEach(function(candy) {
    if (this.quickMatchCheck(candy)) {
      this.board.checkMatchList.push(candy);
    }
  }, this);

};


G.BoardMatcher.prototype.processTempSpecial = function(processData) {
  var exes;
  var candy;

  if (processData instanceof G.Candy) {
    candy = processData;
    exes = candy.getSpecialExe();
  } else {
    candy = this.board.getCandy(processData.cellX, processData.cellY);
    exes = processData.exe;
  }

	if (!exes) return;

	for (var i = 0, len = exes.length; i < len; i++) {

		var currentExe = exes[i];

		if (currentExe[0] == 'loop') {this.processSpecialExeLoop(candy,currentExe[1])};
		if (currentExe[0] == 'specific') {this.processSpecialExeSpecific(candy,currentExe[1])};
		if (currentExe[0] == 'matchType') {this.processSpecialExeMatchType(candy,currentExe[1])};
		if (currentExe[0] == 'changeTypeInto') {this.processSpecialExeChangeTypeInto(candy,currentExe[1],currentExe[2])};
		if (currentExe[0] == 'perform') {this.processSpecialExePerform(candy,currentExe[1])};
		if (currentExe[0] == 'superSpiral') {this.processSpecialExeSuperSpiral(candy,currentExe[1])};

	};

	this.copyTempGridToMatchGrid();

};

G.BoardMatcher.prototype.processSpecialExeLoop = function(candy,posObj) {

	G.sfx.line.play();

	var xx = candy.cellX;
	var yy = candy.cellY;
	var candy;

	while(true) {
		//if pos is out of board, break
		if (!this.board.isCellInBoardArea(xx,yy)) break;

		//check if cell is matchable and not marked for match on matchgrid
		this.tempCheckAndMark(xx,yy);		

		//change coords
		xx += posObj.x;
		yy += posObj.y;

	}

}; 

G.BoardMatcher.prototype.processSpecialExePerform = function(candy,name) {
	candy[name]();
};

G.BoardMatcher.prototype.processSpecialExeSpecific = function(candy,posArray) {

	G.sfx.boom.play();	
	var cellX = candy.cellX;
	var cellY = candy.cellY;
	G.sb("fx").dispatch('explosion',candy);
	var xx, yy;
	for (var i = 0, len = posArray.length; i < len; i+=2) {
		xx = cellX + posArray[i];
		yy = cellY + posArray[i+1];
		this.tempCheckAndMark(xx,yy);
	}
};

G.BoardMatcher.prototype.processSpecialExeMatchType = function(candy,exeType) {

	G.sfx.lightning.play();	 
	//if LASTMOVEDWITH get type of last candy that was moved with
	//if not pick random type
	if (exeType == 'LASTMOVEDWITH') {
		if (candy.lastMovedWith) {
			exeType = candy.lastMovedWith.getMatchToken();
		}else {
			exeType = game.rnd.between(1,this.board.MAX_NUMBER_OF_REGULAR_CANDY);
		}
	};

	if (exeType == "CANDYTYPE") {
		exeType = candy.getMatchToken();
	}

	//if candy is still on board, match it cell (it can be out if it is daleyed, that why there is if)
	if (this.board.getCandy(candy.cellX,candy.cellY) == candy) {
		this.tempGrid.set(candy.cellX,candy.cellY,'m');
	}

	this.board.boardCandies.grid.loop(function(elem,x,y) {
		if (elem && elem.getMatchToken() == exeType) {
			if (this.tempCheckAndMark(x,y,true)) {
				G.sb("fx").dispatch('lightning',candy,[x,y]);
			};
		}
	},this);

};

G.BoardMatcher.prototype.processSpecialExeChangeTypeInto = function(candy,changeTarget,changeInto) {


	//if LASTMOVEDWITH get type of last candy that was moved with
	//if not pick random type
	
	if (changeTarget == "CANDYTYPE") {
		changeTarget = candy.getMatchToken();
	};

	if (changeInto == 'SPECIALLASTMOVED') {
		changeInto = candy.lastMovedWith.getSpecialTypeName();
	};

	//if candy is still on board, match it cell (it can be out if it is daleyed, that why there is if)
	if (this.board.getCandy(candy.cellX,candy.cellY) == candy) {
		this.tempGrid.set(candy.cellX,candy.cellY,'m');
	}

	this.board.boardCandies.grid.loop(function(elem,x,y) {
		if (elem && elem.getMatchToken() == changeTarget && !elem.hasSpecialType() && elem !== candy) {
			if (this.board.isCellMatchable(x,y) && this.board.isMoveable(x,y)) {
				this.board.checkAfterFall.push(elem);
				elem.changeInto(changeInto);
				G.sb("fx").dispatch('lightning',candy,[x,y]);
			}
		}
	},this);

};

G.BoardMatcher.prototype.processSpecialExeSuperSpiral = function(candy) {

	this.board.boardData.loop(function(val, x, y) {
    if (this.board.isCellOnBoard(x,y)) {
      this.tempCheckAndMark(x, y);
    }
  }, this);

};

G.BoardMatcher.prototype.tempCheckAndMark = function(xx,yy,hitOnlyIfMAtch) {

	if (!hitOnlyIfMAtch) this.hitGrid.set(xx,yy,true);

	if (this.board.isCellMatchable(xx,yy) && !this.grid.get(xx,yy)) {
		candy = this.board.getCandy(xx,yy);
		if (candy.hasSpecialType()) {
			this.specialCandiesToProcess.push(candy);
			this.tempGrid.set(xx,yy,'mSpecial');
			this.hitGrid.set(xx,yy,true);
			return true;
		}else {
			this.tempGrid.set(xx,yy,'m');
			this.hitGrid.set(xx,yy,true);
			return true;
		}
	}

	return false;
};




G.BoardMatcher.prototype.processTemp = function(candy) {

	var candiesInMatch = [candy];

	var currentCandy;
	var currentMatchCandy;
	var horPos;
	var vertPos;
	var birdPos;
	var allPos;


	//check candies that makes matches, and push them to candies in match
	for (var i = 0; i < candiesInMatch.length; i++) {

		currentCandy = candiesInMatch[i];

		//get all matches position to one array
		allPos = [];

		horPos = this.getHorizontalMatchPos(currentCandy,this.quickCheckCoords(currentCandy,this.horCoords,false));
		vertPos = this.getVerticalMatchPos(currentCandy,this.quickCheckCoords(currentCandy,this.verCoords,false));
		//birdPos = this.getBirdMatchPos(currentCandy); 
		//birdPos = [];
		allPos = [].concat(horPos,vertPos);

		//check if candy form position is already in candiesInMatch. if not - push it.
		for (var j = 0, len = allPos.length; j < len; j += 2) {
			currentMatchCandy = this.board.getCandy(allPos[j],allPos[j+1]);
			if (candiesInMatch.indexOf(currentMatchCandy) == -1) {
				candiesInMatch.push(currentMatchCandy);
			}
		}

	};

	//use temp grid to mark all matches
	// in case of special use mSpecial, so specials are not part of new specials
	candiesInMatch.forEach(function(elem) {
		if (elem.hasSpecialType()) {
			//appearance test
			// this.tempGrid.set(elem.cellX,elem.cellY,'mSpecial');
			this.tempGrid.set(elem.cellX,elem.cellY,'m');
			this.specialCandiesToProcess.push(elem);
		}else {
			this.tempGrid.set(elem.cellX,elem.cellY,'m');
		}
	},this);


	//check if marks on tempGrid creates any special candy. S
	//special candies have priorities, so we dont block more powerfull with less powerfull
	this.searchAndProcessSpecialsInTemp(candiesInMatch[0]);


	this.copyTempGridToMatchGrid();

};


G.BoardMatcher.prototype.copyTempGridToMatchGrid = function() {

	var nrOfElements = 0;

	var totalX = 0;
	var totalY = 0;

	var colors = [];
	var expColor = false;

	this.tempGrid.loop(function(elem,x,y) {
		if (elem) {
			nrOfElements++;
			totalX += x;
			totalY += y;

			var candy = this.board.getCandy(x,y);

			if (candy && colors.indexOf(candy.getMatchToken()) === -1) colors.push(candy.getMatchToken());

			if (elem == 'mSpecial') {
				this.grid.set(x,y,'m');
			}else {
				this.grid.set(x,y,elem);
			}
		}
	},this);

	if (colors.length == 1) {
		expColor = colors[0];
	}

	if (nrOfElements > 0) {
		G.lvl.processMatch(nrOfElements,totalX/nrOfElements,totalY/nrOfElements,expColor);
	}

	this.tempGrid.clear();


};

G.BoardMatcher.prototype.searchAndProcessSpecialsInTemp = function(priorityCandy) {
	mainLoop:
	while(true) {

		for (var specialIndex = 0, len = this.specialsCoordinates.length; specialIndex < len; specialIndex++) {
			for (var specialCoordIndex = 0, len2 = this.specialsCoordinates[specialIndex][1].length; specialCoordIndex < len2; specialCoordIndex++) {

				var pattern = this.tempGrid.findPattern(this.specialsCoordinates[specialIndex][1][specialCoordIndex],'m');
				if (pattern) {
					if (this.pushSpecialToTempGrid(pattern,this.specialsCoordinates[specialIndex][0],priorityCandy)) {
						specialCoordIndex--;
					}

					//continue mainLoop;
				}
			}
		}
		break;
	};

};

G.BoardMatcher.prototype.pushSpecialToTempGrid = function(coords,special,priorityCandy) {

	var markedChange = false;
	var i;
	var len = coords.length;

	//to make if later
	var changeArray = ['change',special];
	//args to match-move
	var moveToX = coords[0];
	var moveToY =	coords[1];

	var anyChanges = false;

	//to special appears at position of moved candy
	if (priorityCandy) {
		for (i = 0; i <len; i+=2) {

			var candyAtPosition = this.board.getCandy(coords[i],coords[i+1]);

			if (coords[i] == priorityCandy.cellX && coords[i+1] == priorityCandy.cellY 
				&& !this.board.isBoosterChangeBlocked(coords[i],coords[i+1])) {
				markedChange = true;
				moveToX = coords[i];
				moveToY = coords[i+1];
				this.tempGrid.set(coords[i],coords[i+1],changeArray);
				anyChanges = true;
				break;
			}
		}
	}


	//
	for (i = 0; i < len; i+=2) {
		//change candy into special one
		if (i == 0 && !markedChange
			&& !this.board.isBoosterChangeBlocked(coords[i],coords[i+1])) {
			this.tempGrid.set(coords[i],coords[i+1],changeArray);
			anyChanges = true;
		}else {
			//mark animation for merging candies
			if (this.tempGrid.get(coords[i],coords[i+1]) != changeArray
				// && !this.board.getCandy(coords[i],coords[i+1]).wrapped
				&& !this.board.getCandy(coords[i],coords[i+1]).hasStatus()
				&& !this.board.boardCage.isToken(coords[i],coords[i+1])) {
				this.tempGrid.set(coords[i],coords[i+1],['match-move',0,moveToX,moveToY]);
				anyChanges = true;
			}
		}
	}

	return anyChanges;

};


//
// Simple loop that returns candies that are matching in horizontal
// (checkQuickCoords only checks candies that are required to make match,
//  but it doesnt check 4th, 5th candy etc)
//	
// RETURN candiesThatMakesMatch
//
G.BoardMatcher.prototype.getHorizontalMatchPos = function(candy,match) {
	var result = [];
	var cellX = candy.cellX;
	var cellY = candy.cellY;


	if (!match) return result;

	var left = candy.cellX;
	var right = candy.cellX;

	result.push(candy.cellX,candy.cellY);

	while (true) {
		if (this.board.isCellMatchable(--left,cellY,candy) && !this.grid.get(left,cellY)) {
			result.push(left,cellY);
		}else break;
	}

	while (true) {
		if (this.board.isCellMatchable(++right,cellY,candy) && !this.grid.get(right,cellY)) {
			result.push(right,cellY);
		}else break;
	}

	return result;

};

//
// same shit as above
//
G.BoardMatcher.prototype.getVerticalMatchPos = function(candy,match) {
	var result = [];
	var cellX = candy.cellX;
	var cellY = candy.cellY;

	if (!match) return result;

	var up = cellY;
	var down = cellY;

	result.push(candy.cellX,candy.cellY);

	while (true) {
		if (this.board.isCellMatchable(cellX,--up,candy) && !this.grid.get(cellX,up)) {
			result.push(cellX,up);
		}else break;
	}
	
	while (true) {
		if (this.board.isCellMatchable(cellX,++down,candy) && !this.grid.get(cellX,down)) {
			result.push(cellX,down);
		} else break;
	}

	return result;

};

G.BoardMatcher.prototype.getBirdMatchPos = function(candy) {

	var result = [];

	var cellX = candy.cellX;
	var cellY = candy.cellY;
	var len;

	for (var i = 0; i < 4; i++) {
			if (	this.board.isCellMatchable(cellX+this.birdCoords[i][0],cellY+this.birdCoords[i][1],candy)
				&& 	this.board.isCellMatchable(cellX+this.birdCoords[i][2],cellY+this.birdCoords[i][3],candy)
				&&  this.board.isCellMatchable(cellX+this.birdCoords[i][4],cellY+this.birdCoords[i][5],candy)
				) {
				result.push(cellX+this.birdCoords[i][0],cellY+this.birdCoords[i][1],
										cellX+this.birdCoords[i][2],cellY+this.birdCoords[i][3],
										cellX+this.birdCoords[i][4],cellY+this.birdCoords[i][5]);
			}
		}

	return result;

};


G.BoardMatcher.prototype.possibleDownMoves = [
	//hor
	[-1,1,1,1],
	[1,1,2,1],
	//vert
	[-2,1,-1,1],
	[0,2,0,3],
];

G.BoardMatcher.prototype.possibleRightMoves = [
	//hor
	[2,0,3,0],
	//vert
	[1,1,1,2],
	[1,-1,1,1],
	[1,-2,1,-1],

];

G.BoardMatcher.prototype.possibleLeftMoves = [
	//hor
	[-3,0,-2,0],
	//vert
	[-1,-2,-1,-1],
	[-1,-1,-1,1],
	[-1,1,-1,2],

];

G.BoardMatcher.prototype.possibleUpMoves = [
	//hor
	[-1,-1,1,-1],
	[1,-1,2,-1],
	[-2,-1,-1,-1],
	//vert
	[0,-3,0,-2],

]

G.BoardMatcher.prototype.horCoords = [
	//hor center
	[-1,0,1,0],
	//hor left
	[-2,0,-1,0],
	//hor right
	[1,0,2,0]
];

G.BoardMatcher.prototype.verCoords = [
	//ver center
	[0,-1,0,1],
	//ver top
	[0,-1,0,-2],
	//ver bottom
	[0,1,0,2] 
];

G.BoardMatcher.prototype.birdCoords = [
	[-1,-1,-1,0,0,-1],
	[1,0,0,-1,1,-1],
	[-1,0,-1,1,0,1],
	[1,0,0,1,1,1]
];
